// frontend/src/components/UserTypeBadge.jsx
import React from 'react';

export const UserTypeBadge = ({ tipoResidente, size = 'sm' }) => {
    const config = {
        proprietario: {
            label: 'Proprietário',
            color: 'bg-green-100 text-green-700 border-green-200',
            dotColor: 'bg-green-500'
        },
        morador: {
            label: 'Morador',
            color: 'bg-blue-100 text-blue-700 border-blue-200',
            dotColor: 'bg-blue-500'
        }
    };

    const type = tipoResidente || 'morador';
    const { label, color, dotColor } = config[type] || config.morador;

    const sizeClasses = {
        sm: 'px-2 py-0.5 text-xs',
        md: 'px-3 py-1 text-sm',
        lg: 'px-4 py-1.5 text-base'
    };

    return (
        <span className={`inline-flex items-center gap-1.5 rounded-full font-medium border ${color} ${sizeClasses[size] || sizeClasses.sm}`}>
            <span className={`w-1.5 h-1.5 rounded-full ${dotColor}`}></span>
            {label}
        </span>
    );
};

export default UserTypeBadge;